import type { DatesSetArg } from '@fullcalendar/core';
import { format } from 'date-fns';

import { CALENDAR_API_PATHS, CALENDAR_API_QUERY_VIEWS } from '@/app/(main)/calendar/consts/calendar-api';
import type { CalendarApiQueryEventType } from '@/app/(main)/calendar/utils/mapCalendarVisibilityToApiEventTypes';
import type { CalendarViewMode } from '@/types/calendarTypes';

type GetCalendarUrlParams = {
  date: string;
  view: CalendarViewMode;
  eventTypes: CalendarApiQueryEventType[];
};

const VIEW_MODE_TO_API: Record<CalendarViewMode, (typeof CALENDAR_API_QUERY_VIEWS)[keyof typeof CALENDAR_API_QUERY_VIEWS]> =
  {
    day: CALENDAR_API_QUERY_VIEWS.DAILY,
    week: CALENDAR_API_QUERY_VIEWS.WEEKLY,
    month: CALENDAR_API_QUERY_VIEWS.MONTHLY,
  };

export function getCalendarQueryDate(arg: DatesSetArg): string {
  return format(arg.view.currentStart, 'yyyy-MM-dd');
}

export function getCalendarItemsUrl({ date, view, eventTypes }: GetCalendarUrlParams) {
  const params = new URLSearchParams();
  params.set('view', VIEW_MODE_TO_API[view]);
  params.set('date', date);

  for (const eventType of eventTypes) {
    params.append('eventTypes[]', eventType);
  }

  return `${CALENDAR_API_PATHS.FEED}?${params.toString()}`;
}
